<app-admin-boilerplate>
    @if (lrpEvent$ | async; as lrpEvent){
        <app-event-headline [event]="lrpEvent" admin/>
        <div class="flex justify-between">
            <div>
                <h2>Event Tickets</h2>
                <p>Below is a list of all the event tickets available for your event. </p>
            </div>
            <div>
                <!-- <button class="outline-button button-small mt-4 me-4"><fa-icon [icon]="['fas','circle-plus']"/>Add a new ticket</button> -->
            </div>
        </div>
        
        @if (lrpEvent.eventTickets.length > 0){
            
            <div class="bg-amber-100/60 rounded-lg p-6 mt-4 text-sm">
                <p class="mb-3">It is currently possible to edit tickets that have been purchased. Please take greate care doing so. </p>
                <p>We are gradually implementing safety restrictions here, to protect you and your players from accidental changes.</p>
            </div>
            <app-tickets-table [ticketList]="(availableTickets$ | async) ?? []" />
            <button class="outline-button button-small ms-8" (click)="showNewModal = true"><fa-icon class="me-3" [icon]="['fas','circle-plus']"/>Add a ticket</button>
            
            @if (unavailableTickets$ | async; as unavailableTickets){
                <div class="bg-lrpTicketRed/10 rounded-lg p-6 mt-8">
                    <h4 class="!mt-0">The following tickets are no longer available for purchase</h4>
                    <app-tickets-table [ticketList]="unavailableTickets" />
                </div>
            }
        }
        @else {
            Create your first event ticket
        }
        <p-dialog [(visible)]="showNewModal" [modal]="true" [dismissableMask]="true" header="Create new ticket">
            <app-new-ticket [lrpEvent]="lrpEvent" />
        </p-dialog>
    }
</app-admin-boilerplate>